import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShoppingList } from '../context/ShoppingListProvider';
import { formatQty } from '../utils/recipeIngredients';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';

const ShoppingList = () => {
  const {
    items,
    uncheckedCount,
    toggleItem,
    removeItem,
    clearChecked,
    clearAll,
    toText,
  } = useShoppingList();
  const [status, setStatus] = useState('');

  const copyList = async () => {
    try {
      await navigator.clipboard.writeText(toText());
      setStatus('Copied shopping list to clipboard.');
    } catch {
      setStatus('Could not copy. Select the list and copy it manually.');
    }
  };

  const grouped = items.reduce((acc, item) => {
    const key = item.recipeName || 'Other';
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  return (
    <div className="recipe-lab shopping-list-page">
      <header className="recipe-lab-header">
        <Link to="/recipes" className="recipe-lab-back">
          <i className="bi bi-arrow-left" /> Back to Recipe Book
        </Link>
        <h1 className="recipe-lab-title">Shopping List</h1>
        <p className="recipe-lab-subtitle">
          Add ingredients from any recipe. Quantities merge when the name and unit match.
        </p>
      </header>

      {status && (
        <div className="recipe-status-banner" role="status">
          <i className="bi bi-check-circle-fill" /> {status}
        </div>
      )}

      {items.length === 0 ? (
        <div className="recipe-empty-state">
          <i className="bi bi-basket recipe-empty-icon" />
          <p>Your list is empty. Open a recipe and tap “Add to list”.</p>
          <Link to="/recipes" className="recipe-btn recipe-btn-primary">
            <i className="bi bi-journal-bookmark" /> Browse recipes
          </Link>
        </div>
      ) : (
        <>
          <div className="shopping-list-toolbar">
            <span className="recipe-count">
              {uncheckedCount} to buy · {items.length} total
            </span>
            <div className="shopping-list-actions">
              <button type="button" className="recipe-btn" onClick={copyList}>
                <i className="bi bi-clipboard" /> Copy
              </button>
              <button type="button" className="recipe-btn" onClick={() => window.print()}>
                <i className="bi bi-printer" /> Print
              </button>
              <button type="button" className="recipe-btn" onClick={clearChecked} disabled={!items.some((item) => item.checked)}>
                <i className="bi bi-check2-all" /> Clear checked
              </button>
              <button type="button" className="recipe-btn recipe-btn-danger" onClick={clearAll}>
                <i className="bi bi-trash" /> Clear all
              </button>
            </div>
          </div>

          {Object.entries(grouped).map(([group, groupItems]) => (
            <section key={group} className="shopping-list-group">
              <h2 className="shopping-list-group-title">{group}</h2>
              <ul className="shopping-list-items">
                {groupItems.map((item) => (
                  <li key={item.id} className={`shopping-list-item${item.checked ? ' checked' : ''}`}>
                    <label className="shopping-list-check">
                      <input
                        type="checkbox"
                        checked={item.checked}
                        onChange={() => toggleItem(item.id)}
                      />
                      <span>
                        <strong>
                          {[formatQty(item.quantity), item.measurement].filter(Boolean).join(' ')}
                        </strong>
                        {' '}
                        {item.name}
                      </span>
                    </label>
                    <button
                      type="button"
                      className="recipe-icon-btn"
                      onClick={() => removeItem(item.id)}
                      title="Remove item"
                    >
                      <i className="bi bi-x-lg" />
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </>
      )}
    </div>
  );
};

export default ShoppingList;
